import React from "react";
import { connect } from "react-redux";
import "./_PriceDisplay.scss";
import { ReactComponent as EyeIcon } from "../../assets/svg/eye-icon.svg";
import { ReactComponent as EyeIconClosed } from "../../assets/svg/eye-closed-icon.svg";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class PriceDisplayNecklace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priceHidden: false,
    };
  }

  renderNecklacePrice = (necklace, memories) => {
    if (this.state.priceHidden) {
      return <span className="price-text transparent">0000 €</span>;
    }
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    let totalPrice = 0;
    if (queryParams && necklace) {
      totalPrice += this.getPriceByMaterial(
        queryParams["necklace-material"],
        necklace
      );
      if (memories && memories.length) {
        for (let i = 0; i < memories.length; i++) {
          totalPrice += this.getPriceByMaterial(
            queryParams[`mm${memories[i].index}`],
            memories[i].memory
          );
        }
      }
    }
    if (totalPrice === 0) {
      return <span className="price-text text-format">Ota yhteyttä</span>;
    }
    return <span className="price-text">{`${totalPrice} €`}</span>;
  };

  getPriceByMaterial = (material = "yellow-gold", item) => {
    if (item && item.fields) {
      switch (material) {
        default:
          return item.fields.priceYellowGold;
        case "rose-gold":
          return item.fields.priceRoseGold;
        case "white-gold":
          return item.fields.priceWhiteGold;
      }
    }
  };

  onPress = () => {
    this.setState((prevState) => ({
      priceHidden: !prevState.priceHidden,
    }));
  };

  renderPriceTogglebutton = () => {
    if (this.state.priceHidden) {
      return (
        <EyeIconClosed
          className="price-toggle-button"
          onClick={() => this.onPress()}
        />
      );
    } else {
      return (
        <EyeIcon
          className="price-toggle-button"
          onClick={() => this.onPress()}
        />
      );
    }
  };

  render() {
    const { activeMemories, activeNecklace, title } = this.props;
    return (
      <div className="price-display">
        <span className="component-title">
          {title}
          {this.renderPriceTogglebutton()}
        </span>
        {this.renderNecklacePrice(activeNecklace, activeMemories)}
      </div>
    );
  }
}

const mapStateToProps = ({ necklace }) => {
  const { activeNecklace, activeMemories } = necklace;

  return {
    activeMemories,
    activeNecklace,
  };
};

export default connect(mapStateToProps, {})(withRouter(PriceDisplayNecklace));
